import { Component, Input, Renderer2 } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-report-pdf',
  templateUrl: './report-pdf.component.html',
  styleUrls: ['./report-pdf.component.scss']
})
export class ReportPdfComponent {
  @Input() targetId!: string;
  @Input() fileName: string = 'Report.pdf';
  @Input() titleName: string = 'Report';

  public institution = JSON.parse(localStorage.getItem('institution') || '{}');
  public logo_path = (localStorage.getItem('logo_path') || '').replace(/"/g, '');

  constructor(private renderer: Renderer2) {}

  async downloadPDF(): Promise<void> {
    const mainContent = document.getElementById(this.targetId);
    if (!mainContent) {
      console.error(`Element with id "${this.targetId}" not found.`);
      return;
    }

    const container = this.renderer.createElement('div');
    this.renderer.setStyle(container, 'width', '210mm');
    this.renderer.setStyle(container, 'padding', '10mm');
    this.renderer.setStyle(container, 'background', '#fff');
    this.renderer.setStyle(container, 'position', 'absolute');
    this.renderer.setStyle(container, 'top', '-9999px');
    this.renderer.setStyle(container, 'left', '-9999px');
    this.renderer.setStyle(container, 'z-index', '-1');

    const headerHTML = `
      <div style="display:grid;grid-template-columns:58% 42%;margin-bottom:20px;">
        <div style="display:flex;align-items:center;">
          ${
            this.institution?.INSTITUTION_LOGO
              ? `<img src="${this.logo_path}${this.institution.INSTITUTION_LOGO}" 
                   width="120" height="120" 
                   style="object-fit:contain;display:block;margin-left:0;width:auto;" />`
              : ''
          }
        </div>
        <div>
          <h5 style="font-size:16px;font-weight:bold;margin:0;">${this.institution.INSTITUTION_NAME || ''}</h5>
          <div style="font-size:12px;line-height:18px;margin-top:10px;">
            ${this.institution.INSTITUTION_ADDRESS || ''}<br/>
            ${this.institution.INSTITUTION_CITY || ''}, ${this.institution.INSTITUTION_COUNTRY_NAME || ''}<br/>
            Ph: ${this.institution.INSTITUTION_PHONE_NO || ''}<br/>
            Email: ${this.institution.INSTITUTION_EMAIL || ''}<br/>
            VAT IN: ${this.institution.INSTITUTION_VAT_NO || ''}
          </div>
        </div>
      </div>
      <div style="font-size:22px;font-weight:bold;padding:15px;text-align:center;width:100%;">
        ${this.titleName || 'REPORT'}
      </div>
    `;

    container.innerHTML = headerHTML;

    const clonedBody = mainContent.cloneNode(true);
    container.appendChild(clonedBody);
    document.body.appendChild(container);

    try {
      const canvas = await html2canvas(container, { scale: 2.0, useCORS: true });
      const imgData = canvas.toDataURL('image/jpeg', 0.85);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210; 
      const pageHeight = 297; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(this.fileName);
    } catch (error) {
      console.error('PDF generation failed:', error);
    } finally {
      document.body.removeChild(container);
    }
  }
}